import React from "react";
import { Box } from "@theme-ui/components";

const Table = ({ innerContent }) => (
  <Box
    sx={{
      width: "100%",
      overflowX: "scroll",
      figure: {
        bg: "white",
        minWidth: "100%",
        display: "inline-block",
      },
      my: [4],
      table: {
        bg: "offWhite",
        width: "100%",
        borderSpacing: "1px",
      },
      tbody: {
        p: [3],
      },
      td: {
        fontSize: [2, 3],
        py: 2,
        px: [2, 3],
        lineHeight: 1.3,
      },
      "& tr": {
        bg: "white",
        width: "33.3333333%",
      },
    }}
    dangerouslySetInnerHTML={{ __html: innerContent }}
  />
);

export default Table;
